import React from 'react'

import { Template, Breadcrumb } from '@components'

function DashboardBI() {
	const pages = [{ name: 'Dashboard BI', href: '#', current: true }]

	return (
		<Template>
			<Breadcrumb pages={pages} />

			<iframe
				src='https://metabase.betalent.tech/public/dashboard/e61d8113-6a74-4fe4-81c5-a5b864b44aae'
				className='w-full h-[800px] border-none outline-none shadow-none'
				title='Dashboard BI do Metabase'
			/>
		</Template>
	)
}

export default DashboardBI
